import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const API = `${environment.api}/timeline/`;

@Injectable({
  providedIn: 'root'
})
export class TimelineService {
  private readonly http: HttpClient = inject(HttpClient);

  // get of all weeks in a selected month
  all_weeks_in_month(
    year: string,
    month: string,
    choserUser?: any
  ): Observable<any> {
    return this.http.get<any>(API + 'allWeeksInMonth', {
      params: new HttpParams()
        .set('year', year)
        .set('month', month)
        .set('chosenUser', choserUser)
    });
  }

  // get current year,month and week
  current_date(): Observable<any> {
    return this.http.get<any>(API + 'currentDate');
  }
}
